var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2347_3622)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 14C13.99 14 16 13 16 11.5V2C16 1 14 0 11.5 0C9 0 7 1 7 2V5.5C8.17 5.99 9.17 6.81 9.88 7.85C10.37 7.946 10.91 7.999 11.5 7.999C12.81 7.999 13.9 7.738 14.68 7.313C14.7907 7.25214 14.8985 7.18606 15.003 7.115V8.495C15.003 8.73 14.816 9.095 14.201 9.431C13.605 9.756 12.691 9.995 11.501 9.995C11.263 9.995 11.0363 9.986 10.821 9.968C10.901 10.298 10.9543 10.6347 10.981 10.978C11.1497 10.9873 11.323 10.992 11.501 10.992C12.811 10.992 13.901 10.731 14.681 10.306C14.7917 10.2451 14.8995 10.1791 15.004 10.108V11.488C15.004 11.724 14.855 12.074 14.213 12.42C13.581 12.76 12.633 12.988 11.503 12.988C11.273 12.988 11.0503 12.9787 10.835 12.96C10.7581 13.2924 10.6548 13.6181 10.526 13.934C10.8407 13.9693 11.166 13.987 11.502 13.987L11.5 14ZM14.2 6.44C14.815 6.104 15.002 5.739 15.002 5.504V4.124C14.8987 4.19467 14.791 4.26067 14.679 4.322C13.901 4.747 12.809 5.008 11.499 5.008C10.189 5.008 9.099 4.747 8.319 4.322C8.20827 4.26114 8.10048 4.19506 7.996 4.124V5.504C7.996 5.739 8.183 6.104 8.798 6.439C9.394 6.764 10.308 7.003 11.498 7.003C12.688 7.003 13.598 6.764 14.198 6.439L14.2 6.44ZM8 2.5C8 2.212 8.125 1.935 8.358 1.766C8.485 1.674 8.623 1.582 8.732 1.532C9.005 1.406 10.372 0.999 11.502 0.999C12.632 0.999 13.612 1.226 14.272 1.532C14.396 1.589 14.533 1.678 14.654 1.766C14.885 1.933 15.004 2.208 15.004 2.493V2.499C15.004 2.734 14.817 3.099 14.202 3.435C13.606 3.76 12.692 3.999 11.502 3.999C10.312 3.999 9.402 3.759 8.802 3.435C8.187 3.1 8 2.734 8 2.5Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11.5C9 13.99 6.99 16 4.5 16C2.01 16 0 13.99 0 11.5C0 9.01 2.01 7 4.5 7C6.99 7 9 9.01 9 11.5ZM8 11.5C8 13.43 6.43 15 4.5 15C2.57 15 1 13.43 1 11.5C1 9.57 2.57 8 4.5 8C6.43 8 8 9.57 8 11.5Z",
    fill: "#939393"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2347_3622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.85bc1928d104db935284a44afa32e8fc.svg";
export { ForwardRef as ReactComponent };